import { useThreadAccess } from '@components/ArtBoard/Threads/hooks'
import type { ID } from '@octopus-do/octopus-project-core'
import { type Thread, ThreadsActions } from '@store/reducers/threads'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { useBooleanState } from '@/hooks'
import type { Recipient } from '@/types'
import { ResolveButton } from '../ResolveButton'
import { ThreadActions } from '../ThreadActions'
import { ThreadComment } from '../ThreadComment'

interface Props {
  thread: Thread
  users: Record<ID, Recipient>
}

export const InitialComment: React.FC<Props> = ({ users, thread }) => {
  const dispatch = useDispatch()
  const { value: readOnly, toggle, setTrue } = useBooleanState(true)

  const { updatedAt, createdAt, content, resolved, owner, uuid } = thread
  const author = owner ? users[owner] : null

  const onSubmit = (content: string) => {
    dispatch(ThreadsActions.edit({ uuid, content }))
    setTrue()
  }

  const onResolveClick = () => {
    const action = resolved ? ThreadsActions.reopen : ThreadsActions.resolve

    dispatch(action({ id: uuid }))
  }

  const canResolve = useThreadAccess(uuid, 'resolve')
  const actionAuthor = author ? author.id : null

  return (
    <ThreadComment
      onSubmit={onSubmit}
      updatedAt={updatedAt}
      createdAt={createdAt}
      content={content}
      author={author}
      storedName={thread.author}
      readOnly={readOnly}
      onCancel={setTrue}
    >
      {canResolve && (
        <ResolveButton resolved={resolved} onClick={onResolveClick} />
      )}
      <ThreadActions
        author={actionAuthor}
        id={uuid}
        onEdit={toggle}
        resolved={resolved}
      />
    </ThreadComment>
  )
}
